import { invokeApi } from "../../bl_libs/invokeApi";

/**
 * Upload a file for an automation email.
 * Backend sets `deliverAs` from size; send prefers MIME attach (incl. video).
 * Resolves `{ code, message, attachment }` (invokeApi shape, never throws on HTTP errors).
 */
export const uploadTrackerAutomationAttachmentApi = async ({ file, trackerId }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("trackerId", String(trackerId || ""));
  return invokeApi({
    path: `/api/tracker_automation/attachment`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: formData,
  });
};

export const deleteTrackerAutomationAttachmentApi = async (id) =>
  invokeApi({
    path: `/api/tracker_automation/attachment/${encodeURIComponent(id)}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  });
